import store from '../'

let resource = store.defineResource({
  name: "questionGroups",
  relations: {
    hasMany: {
      questions: {
        localField: "questions",
        foreignKey: "groupId"
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/questionGroups.js